import "./App.css";
import "./winter.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import OnePage from "./pages/OnePage";
import SprinklerHome from "./pages/SprinklerHome";
import OwnerPage from "./pages/OwnerPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SprinklerHome />} />
          <Route path="/backflow" element={<OnePage />} />
          <Route path="/owner" element={<OwnerPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
